<template>
  <div class="big">
    <div class="container">
      <div class="searchbox">
        <div class="item">
          <span>变动时间</span>
          <el-date-picker
            v-model="date"
            type="daterange"
            range-separator="~"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            style="width: 240px; margin-left: 6px"
            @change="search"
          >
          </el-date-picker>
        </div>
        <div class="item">
          <span>类型</span>
          <el-select
            :value="log_type"
            value-key="type_name"
            placeholder="请选择"
            style="width: 180px; margin-left: 6px"
            @change="changeSelect"
          >
            <el-option
              v-for="(item, index) in options"
              :key="index"
              :label="item.type_name"
              :value="item"
            >
            </el-option>
          </el-select>
          <el-button
            type="info"
            style="background-color: #eceff2; color: #747981; margin-left: 6px"
            @click="search"
            >查询</el-button
          >
        </div>
      </div>
      <div style="border: solid 1px #c9cbd6">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%; min-width: 1000px"
          :header-cell-style="{ background: '#F5F5F5' }"
        >
          <el-table-column
            label="变动时间"
            prop="create_time"
          ></el-table-column>
          <el-table-column label="类型" prop="title"> </el-table-column>
          <el-table-column label="积分变动">
            <template slot-scope="scope">
              <div>
                <span v-if="scope.row.type == 1">+</span>
                <span>{{ scope.row.integral }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="积分余额"
            prop="surplus_integral"
          ></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="toDetail(scope.row)"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('921') : false
                "
                >详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="padding-top: 20px">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
        ></el-pagination>
      </div>
    </div>
    <!-- 变动详情 -->
    <el-dialog
      :title="detail.title + '积分'"
      :visible.sync="detailDia"
      width="560px"
      :close-on-click-modal="false"
    >
      <div class="content">
        <div>
          <span class="gray">变动时间：</span>
          <span class="weight" style="margin-right: 30px">{{
            detail.create_time
          }}</span>
          <span class="gray">变动积分：</span>
          <span class="weight">
            <span v-if="detail.type == 1">+</span>
            {{ detail.integral }}</span
          >
        </div>
        <div class="content_box">
          <div>
            <!-- 问诊赠送积分/处方订单赠送 -->
            <div v-if="detail.log_type == 1 || detail.log_type == 2">
              <div style="margin: 5px 0">
                <i class="el-icon-s-promotion green"></i>
                <span class="gray weight">新增积分：</span>
              </div>
              <div
                v-for="(item, index) in logList"
                :key="index"
                style="margin-bottom: 10px"
              >
                <div v-if="item.use_type == 1">
                  <span class="gray title">积分产生时间：</span>
                  <span style="margin-right: 30px">{{ item.create_time }}</span>
                  <span v-if="item.use_type">
                    <span class="gray">类型：</span>
                    <span v-if="item.use_type == 1">问诊赠送</span>
                    <span v-if="item.use_type == 2">处方订单赠送</span>
                    <span class="green_num">
                      <span v-if="detail.type == 1">+</span>
                      {{ item.integral }}</span
                    >
                  </span>
                </div>
                <div style="margin-top: 4px" v-if="item.use_type == 1">
                  <span class="gray title">接诊时间：</span>
                  <span style="margin-right: 30px">{{ item.agree_time }}</span>
                  <span class="gray">医生：</span>
                  <span>{{ item.doctor_name }}</span>
                </div>
                <div style="margin-top: 4px" v-if="item.use_type == 2">
                  <span class="gray title">积分产生时间：</span>
                  <span style="margin-right: 30px">{{ item.create_time }}</span>
                  <span class="gray">订单号：</span>
                  <span>{{ item.order_sn }}</span>
                </div>
              </div>
            </div>
            <!-- 消费扣除/过期作废 -->
            <div v-if="detail.log_type == 3 || detail.log_type == 5">
              <div
                class="align-center"
                v-if="detail.log_type == 3"
                style="margin-bottom: 12px"
              >
                <i class="el-icon-s-promotion green"></i>
                <span class="gray">支付时间：</span>
                <span style="margin-right: 30px">{{ info.pay_time }}</span>
                <span class="gray">订单号：</span>
                <span>{{ info.order_sn }}</span>
              </div>
              <div style="margin-bottom: 5px">
                <i class="el-icon-s-promotion green"></i>
                <span class="gray weight">扣除积分：</span>
              </div>
              <div
                v-for="(item, index) in logList"
                :key="index"
                style="margin-bottom: 12px"
              >
                <div>
                  <span class="gray title">● 积分产生时间：</span>
                  <span style="margin-right: 30px">{{ item.create_time }}</span>
                  <span class="gray">类型：</span>
                  <span v-if="item.use_type == 1">问诊赠送</span>
                  <span v-if="item.use_type == 2">处方订单赠送</span>
                  <span v-if="item.use_type == 8">平台赠送</span>
                  <span v-if="item.use_type == 9">歧黄养生卡专享赠送</span>
                  <span v-if="item.use_type == 10">歧黄养生卡专享赠送</span>
                  <span class="green_num">
                    <span v-if="detail.type == 1">+</span
                    >{{ item.integral }}</span
                  >
                </div>
                <div
                  style="margin-top: 4px"
                  v-if="item.use_type == 1 || item.use_type == 9"
                >
                  <span class="gray title" style="padding-left: 12px"
                    >接诊时间：</span
                  >
                  <span style="margin-right: 30px">{{ item.agree_time }}</span>
                  <span class="gray">医生：</span>
                  <span>{{ item.doctor_name }}</span>
                </div>
                <div
                  style="margin-top: 4px"
                  v-if="item.use_type == 2 || item.use_type == 10"
                >
                  <span class="gray title" style="padding-left: 12px">
                    订单号：</span
                  >
                  <span>{{ item.order_sn }}</span>
                </div>
              </div>
            </div>
            <!-- 消费退款返还 -->
            <div v-if="detail.log_type == 4">
              <div class="align-center" style="margin-bottom: 12px">
                <i class="el-icon-s-promotion green"></i>
                <span class="gray">退款时间：</span>
                <span style="margin-right: 30px">{{ info.refund_time }}</span>
                <span class="gray">订单号：</span>
                <span>{{ info.order_sn }}</span>
              </div>
              <div style="margin-bottom: 5px">
                <i class="el-icon-s-promotion green"></i>
                <span class="gray weight">返还积分：</span>
              </div>
              <div
                v-for="(item, index) in logList"
                :key="index"
                style="margin-bottom: 12px"
              >
                <div>
                  <span class="gray title">● 积分产生时间：</span>
                  <span style="margin-right: 30px">{{ item.create_time }}</span>
                  <span class="gray">类型：</span>
                  <span v-if="item.use_type == 1">问诊赠送</span>
                  <span v-if="item.use_type == 2">处方订单赠送</span>
                  <span v-if="item.use_type == 8">平台赠送</span>
                  <span v-if="item.use_type == 9">歧黄养生卡专享赠送</span>
                  <span v-if="item.use_type == 10">歧黄养生卡专享赠送</span>
                  <span class="green_num">
                    <span v-if="detail.type == 1">+</span
                    >{{ item.integral }}</span
                  >
                </div>
                <div
                  style="margin-top: 4px"
                  v-if="item.use_type == 1 || item.use_type == 9"
                >
                  <span class="gray title" style="padding-left: 12px"
                    >接诊时间：</span
                  >
                  <span style="margin-right: 30px">{{ item.agree_time }}</span>
                  <span class="gray">医生：</span>
                  <span>{{ item.doctor_name }}</span>
                </div>
                <div
                  style="margin-top: 4px"
                  v-if="item.use_type == 2 || item.use_type == 10"
                >
                  <span class="gray title" style="padding-left: 12px">
                    订单号：</span
                  >
                  <span>{{ item.order_sn }}</span>
                </div>
              </div>
            </div>
            <!-- 生日、补偿、节日赠送 -->
            <div v-if="detail.log_type == 8">
              <div style="margin: 5px 0">
                <i class="el-icon-s-promotion green"></i>
                <span class="gray weight">新增积分：</span>
              </div>
              <div
                v-for="(item, index) in logList"
                :key="index"
                style="margin-bottom: 10px"
              >
                <div style="margin-top: 4px">
                  <span class="gray title" style="width: 98px"
                    >积分产生时间：</span
                  >
                  <span>{{ item.create_time }}</span>
                </div>
              </div>
            </div>
            <!-- 歧黄养生卡专享赠送 -->
            <div v-if="detail.log_type == 9">
              <div style="margin: 5px 0">
                <i class="el-icon-s-promotion green"></i>
                <span class="gray weight">新增积分：</span>
              </div>
              <div
                v-for="(item, index) in logList"
                :key="index"
                style="margin-bottom: 10px"
              >
                <div style="margin-top: 4px">
                  <span class="gray title" style="width: 98px"
                    >积分产生时间：</span
                  >
                  <span>{{ item.create_time }}</span>
                  <div style="margin-top: 4px">
                    <span class="gray title" style="width: 98px"
                      >接诊时间：</span
                    >
                    <span style="margin-right: 30px">{{
                      item.agree_time
                    }}</span>
                    <span class="gray">医生：</span>
                    <span>{{ item.doctor_name }}</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- 处方养生卡专享赠送 -->
            <div v-if="detail.log_type == 10">
              <div style="margin: 5px 0">
                <i class="el-icon-s-promotion green"></i>
                <span class="gray weight">新增积分：</span>
              </div>
              <div
                v-for="(item, index) in logList"
                :key="index"
                style="margin-bottom: 10px"
              >
                <div style="margin-top: 4px">
                  <span class="gray title" style="width: 98px"
                    >积分产生时间：</span
                  >
                  <span>{{ item.create_time }}</span>
                  <span class="gray" style="padding-left: 12px"> 订单号：</span>
                  <span>{{ item.order_sn }}</span>
                </div>
              </div>
            </div>
            <!-- 兑换权益扣除 -->
            <div v-if="detail.log_type == 11">
              <div style="margin: 5px 0">
                <i class="el-icon-s-promotion green"></i>
                <span class="gray weight">兑换内容:优惠券</span>
              </div>
              <div
                v-for="(item, index) in logList"
                :key="index"
                style="margin-bottom: 10px"
              >
                <div style="margin-top: 4px">
                  <!--   v-if="item.use_type==2 || item.use_type==8" -->
                  <span class="gray title">积分产生时间：</span>
                  <span style="margin-right: 30px">{{ item.create_time }}</span>
                  <span class="gray">变动积分：</span>
                  <span>{{ item.integral }}</span>
                </div>
              </div>
            </div>
            <!-- 随访评价赠送 -->
            <div v-if="detail.log_type == 12">
              <div style="margin: 5px 0">
                <i class="el-icon-s-promotion green"></i>
                <span class="gray weight">新增积分：</span>
              </div>
              <div
                v-for="(item, index) in logList"
                :key="index"
                style="margin-bottom: 10px"
              >
                <div>
                  <span class="gray title">积分产生时间：</span>
                  <span style="margin-right: 30px">{{ item.create_time }}</span>
                  <span class="gray">处方号：</span>
                  <span>{{ item.order_id }}</span>
                </div>
              </div>
            </div>
            <!-- 商城订单赠送 -->
            <div v-if="detail.log_type == 13">
              <div class="align-center" style="margin-bottom: 12px">
                <i class="el-icon-s-promotion green"></i>
                <span class="gray">支付时间：</span>
                <span style="margin-right: 30px">{{ info.pay_time }}</span>
                <span class="gray">订单号：</span>
                <span>{{ info.order_sn }}</span>
              </div>
              <div style="margin-bottom: 5px">
                <i class="el-icon-s-promotion green"></i>
                <span class="gray weight">新增积分：</span>
              </div>
              <div
                v-for="(item, index) in logList"
                :key="index"
                style="margin-bottom: 12px"
              >
                <div>
                  <span class="gray title">● 积分产生时间：</span>
                  <span style="margin-right: 30px">{{ item.create_time }}</span>
                  <span class="gray">类型：</span>
                  <span>商城订单赠送</span>
                  <span class="green_num">
                    <span v-if="detail.type == 1">+</span
                    >{{ item.integral }}</span
                  >
                </div>
                <div
                  style="margin-top: 4px"
                  v-if="item.use_type == 1 || item.use_type == 9"
                >
                  <span class="gray title" style="padding-left: 12px"
                    >接诊时间：</span
                  >
                  <span style="margin-right: 30px">{{ item.agree_time }}</span>
                  <span class="gray">医生：</span>
                  <span>{{ item.doctor_name }}</span>
                </div>
                <div
                  style="margin-top: 4px"
                  v-if="item.use_type == 2 || item.use_type == 10"
                >
                  <span class="gray title" style="padding-left: 12px">
                    订单号：</span
                  >
                  <span>{{ item.order_sn }}</span>
                </div>
              </div>
            </div>
            <!-- 14签到赠送，15连续签到赠送，16分享商品赠送，17分享科普内容赠送，18邀请好友赠送，19商品评价赠送，20分享测评赠送，21分享医生赠送 -->
            <div
              v-if="
                detail.log_type == 14 ||
                detail.log_type == 15 ||
                detail.log_type == 16 ||
                detail.log_type == 17 ||
                detail.log_type == 18 ||
                detail.log_type == 19 ||
                detail.log_type == 20 ||
                detail.log_type == 21
              "
            >
              <div style="margin: 5px 0">
                <i class="el-icon-s-promotion green"></i>
                <span class="gray weight">新增积分：</span>
              </div>
              <div
                v-for="(item, index) in logList"
                :key="index"
                style="margin-bottom: 10px"
              >
                <div>
                  <span class="gray title">积分产生时间：</span>
                  <span style="margin-right: 30px">{{ item.create_time }}</span>
                  <template v-if="item.business_name ">
                    <span>{{ item.business_name }}</span>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import dayjs from "dayjs";
import integralmanage from "../../../api/integralmanage";
export default {
  data() {
    return {
      totalNum: 0,
      currentPage: 1,
      pagesize: 10,
      tableData: [],
      date: [],
      log_type: {
        type: 0,
        type_name: "全部",
      },
      options: [],
      title: "消费退款-返还积分",
      detailDia: false,
      detail: {},
      info: {},
      logList: [],
    };
  },
  props: ["userId"],
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    this.getOptions();
  },
  activated() {
    this.getList();
  },
  methods: {
    //  获取积分赠送类型 积分变动
    getOptions() {
      integralmanage.getIntegralType({ type: 1 }).then((res) => {
        let { code, data } = res;
        if (code === 0) {
          data.list.unshift({
            type: 0,
            type_name: "全部",
          });
          this.options = data.list;
        }
      });
    },
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        user_id: this.userId,
        log_type: this.log_type.type,
        title: this.log_type.type_name,
      };
      if (this.date && this.date.length) {
        data.change_time_start = dayjs(this.date[0]).format("YYYY-MM-DD");
        data.change_time_end = dayjs(this.date[1]).format("YYYY-MM-DD");
      }
      this.axios
        .post("platform/Integral/getUserIntegralLogList", data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list.map((item) => {
              item.create_time = dayjs
                .unix(item.create_time)
                .format("YYYY-MM-DD HH:mm");
              return item;
            });
            this.totalNum = res.data.total;
          }
        });
    },
    //查看详情
    toDetail(row) {
      this.detail = row;
      let log_id = row.log_id;
      this.axios
        .post("platform/Integral/getUserIntegralLogInfo", { log_id })
        .then((res) => {
          if (res.code == 0) {
            this.info = res.data.info;
            this.info.pay_time = this.info.pay_time
              ? dayjs.unix(this.info.pay_time).format("YYYY-MM-DD HH:mm")
              : "";
            this.info.refund_time = this.info.refund_time
              ? dayjs.unix(this.info.refund_time).format("YYYY-MM-DD HH:mm")
              : "";
            this.logList = res.data.list.map((item) => {
              item.create_time = item.create_time
                ? dayjs.unix(item.create_time).format("YYYY-MM-DD HH:mm")
                : "";
              item.agree_time = item.agree_time
                ? dayjs.unix(item.agree_time).format("YYYY-MM-DD HH:mm")
                : "";
              return item;
            });
            this.detailDia = true;
          }
        });
    },
    //搜索
    changeSelect(e) {
      this.log_type = e;
      this.search();
    },
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //翻页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
}
.searchbox {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
  align-items: center;
  box-sizing: border-box;
  .item {
    margin-right: 20px;
  }
}
.content {
  padding: 20px;
  text-align: left;
  .gray {
    color: #666;
    margin-right: 10px;
  }
  .title {
    display: inline-block;
    width: 115px;
    box-sizing: border-box;
  }
  .weight {
    font-weight: 700;
  }
  .green {
    color: #669961;
    font-size: 20px;
  }
  .content_box {
    background: #f5f5f5;
    padding: 10px;
    margin-top: 5px;
  }
  .green_num {
    color: #669961;
    font-size: 20px;
    margin-left: 18px;
  }
}
</style>
